import { LOAD_STATUS_STRING } from '../constants/index';

export const GET_LOAD_STATUS_CLASS = (status: string): string => {
	switch (status.toLowerCase()) {
		case LOAD_STATUS_STRING.ACTIVE.toLowerCase():
		case LOAD_STATUS_STRING.DELIVERED.toLowerCase():
		case LOAD_STATUS_STRING.CONFIRMED.toLowerCase():
			return 'accepted-chip';
		case LOAD_STATUS_STRING.SELECTED.toLowerCase():
			return 'selected-chip';
		case LOAD_STATUS_STRING.IN_TRANSIT.toLowerCase() || LOAD_STATUS_STRING.CONFIRMED.toLowerCase():
			return 'countered-chip';
		case LOAD_STATUS_STRING.CANCELLED.toLowerCase() || LOAD_STATUS_STRING.DELETED.toLowerCase():
			return 'declined-chip';
		default:
			return '';
	}
};
